<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-simple-table
          :dense="dense"
          :fixed-header="fixedHeader"
          :height="height"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Project ID</th>
                <th class="text-left">Name</th>
                <th class="text-left">Status</th>
                <th class="text-left">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in websites" :key="item.id">
                <td>
                  <router-link
                    :to="{
                      name: 'order-website-details',
                      params: { order: item },
                      query: { id: item.id }
                    }"
                  >
                    {{ item.id }}</router-link
                  >
                </td>
                <td>
                  {{ item.project_name }}
                </td>
                <td>
                  {{ item.status }}
                </td>
                <td>
                  {{ item.start_date }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { db } from "@/Firebase";
export default {
  name: "OrderSoftware",
  data() {
    return {
      dense: false,
      fixedHeader: false,
      height: 300,
      headers: [
        {
          text: "Project ID",
          value: "Project_Id"
        },
        { text: "Project Name", value: "Project Name" },
        { text: "Status", value: "Status" },
        { text: "Date", value: "Date" }
      ],
      websites: []
    };
  },
  created() {
    let orderRef = db.collection("orders").doc(this.$store.getters.userId);
    orderRef
      .collection("website")
      .get()
      .then(snapshot => {
        let i = 0;
        snapshot.forEach(doc => {
          this.websites.push(doc.data());
          this.websites[i].id = doc.id;
          i++;
        });
      })
      .catch(function() {
        alert("No orders can be found");
      });
  }
};
</script>
